var _ellipse, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAssistantCtaPage3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 118,
    viewBox: "0 0 110 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_10899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 103
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.0827,
    cy: 49.5,
    rx: 52.0827,
    ry: 49.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_10899)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.0827,
    cy: 49.5,
    rx: 52.0827,
    ry: 49.5,
    fill: "#FFEADB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.808 52.9985C23.0209 52.9985 17.9499 53.669 15.6377 54.0042L26.8066 64.0605C35.8201 61.863 53.7502 57.5402 44.5836 55.4409C34.8255 53.2062 27.0417 52.9985 24.808 52.9985Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5932 53.7865C17.674 53.7826 17.7167 53.7812 17.7167 53.7812L17.6422 53.9186C17.9919 54.7959 20.3068 59.6062 29.2787 60.3988C39.161 61.2718 43.2463 55.1169 43.2463 55.1169C43.2463 55.1169 49.2708 55.9364 51.7707 57.1245C56.9959 61.8422 63.4589 69.2587 68.1385 74.6288C69.0563 75.682 69.9055 76.6564 70.6632 77.5164C76.5416 73.9408 84.7671 69.9832 84.7671 69.9832L91.7036 71.771C91.7036 71.771 89.7909 75.506 84.7671 79.3493C84.4765 79.5717 84.0321 79.9648 83.4542 80.476C80.7906 82.8325 75.2922 87.6969 68.958 89.8934C62.7081 86.8244 57.1873 82.3694 52.7082 74.3504C51.7707 82.3694 54.7447 114.203 55.1401 115.013C56.0916 116.971 57.9617 120.037 57.9617 120.037C57.9617 120.037 22.6762 137.114 12.0941 132.736C11.6007 132.533 10.8758 131.439 10.8758 131.439L10.9737 112.222C-12.2275 92.8623 -5.87029 89.7213 -5.87029 89.7213C-6.20779 83.1342 -0.372585 65.854 4.06022 59.2907C4.54658 58.5706 5.16081 57.9443 5.85808 57.3996C5.98436 57.146 6.07847 56.995 6.12842 56.9567C6.82336 56.4239 7.92065 55.9548 9.16696 55.5521C12.7167 54.122 16.6217 53.8381 17.5236 53.7901C17.5682 53.7842 17.5915 53.7812 17.5915 53.7812C17.5915 53.7812 17.5921 53.783 17.5932 53.7865Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8571 26.3766C24.8571 26.3766 31.2714 49.0874 23.7471 53.1099C28.7545 55.6213 37.6483 55.6085 37.6483 55.6085L38.0166 48.6327C38.0166 48.6327 42.5805 49.4925 43.7675 45.4477C47.966 36.6845 44.3406 22.8398 44.3406 22.8398L24.8571 26.3766Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0183 24.8717C43.9922 25.4188 43.542 28.5843 43.542 28.5843L40.3698 35.2865C38.753 34.075 36.5836 34.1532 36.1538 36.8693C35.8468 38.8428 38.405 39.2336 38.405 39.2336C36.911 41.6566 35.9082 43.6106 33.7388 45.9163C31.3853 48.3979 30.0755 48.6519 27.5377 48.691H24.7339C24.7339 48.691 23.3627 44.4313 20.8249 33.7819C18.0006 21.9602 32.6337 23.4843 35.3556 20.4752C39.7763 15.5706 52.4241 23.1326 46.0183 24.8717Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.449 16.5482C46.449 16.5482 45.876 16.9585 44.9346 17.3884C43.0722 18.2091 39.7567 19.0688 36.298 17.0367C35.7659 16.724 35.2338 16.5091 34.7017 16.3918C30.2606 15.3171 26.0446 20.1631 25.5944 20.7102C24.919 21.3941 24.346 22.1562 23.8957 22.9964C22.1971 23.7194 20.7644 24.9895 19.9049 26.5722C18.5132 29.132 18.7383 33.3721 21.1124 34.8963L23.5273 34.1342C23.6911 34.4273 23.8957 34.7009 24.1413 34.9354C24.3255 35.1112 24.5916 35.2675 24.8371 35.3457C25.1646 35.4434 25.5125 35.4239 25.7581 35.2285C26.0242 35.0135 26.1265 34.6618 26.1879 34.3101C26.2697 33.9388 26.3516 33.5675 26.4335 33.1963L43.7066 27.7055C43.6657 28.1354 43.5429 28.5653 43.3792 28.917C43.3792 28.917 43.3792 28.917 43.3996 28.917C43.4815 28.917 43.8499 28.9366 44.3615 28.8389C45.4462 28.6435 47.2472 28.0182 48.6593 25.9665C50.8492 22.8401 50.2966 18.1114 46.449 16.5482Z",
    fill: "#4B4A50"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.542,
    y: 15.8394,
    width: 46.4578,
    height: 22.5016,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.292,
    y: 19.4038,
    width: 28.333,
    height: 3.564,
    rx: 1.782,
    fill: "#FF7D23"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 29.6235,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 26.1357,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 33.02,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.9265 19.0083L70.4 22.1786L69.1424 21.1219L68.541 21.792L70.4273 23.3643L74.5826 19.6527L73.9265 19.0083Z",
    fill: "#FF7D23",
    stroke: "#FF7D23",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.542,
    y: 40.9863,
    width: 46.4578,
    height: 22.5016,
    rx: 5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 77.292,
    y: 44.5503,
    width: 28.333,
    height: 3.564,
    rx: 1.782,
    fill: "#B7B7B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 54.77,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 51.2822,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 68.0098,
    y: 58.1665,
    width: 37.5236,
    height: 1.188,
    rx: 0.594,
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9265 44.1538L70.4 47.3242L69.1424 46.2674L68.541 46.9375L70.4273 48.5098L74.5826 44.7982L73.9265 44.1538Z",
    fill: "#787B7D",
    stroke: "#787B7D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6961 63.989C91.5445 63.3495 92.3006 62.786 92.3397 62.7794C92.3397 62.7794 95.9585 59.5988 97.0141 59.8923C98.0871 60.1906 97.6007 60.9062 96.3549 62.0589C95.899 62.4811 95.601 62.8619 95.4085 63.1617C95.6779 63.1541 95.9835 63.1939 96.2508 63.3041C96.435 63.3808 96.6151 63.4958 96.7231 63.6305C96.8765 63.8301 96.853 64.0468 96.7472 64.2148C96.7401 64.2261 96.7307 64.2379 96.7193 64.25C96.894 64.2695 97.0721 64.3111 97.2472 64.3796C97.4461 64.4588 97.624 64.5708 97.746 64.7191C97.8962 64.9262 97.8882 65.1548 97.7836 65.319C97.7016 65.4477 97.5687 65.5549 97.4256 65.6514L97.5633 65.7577C97.5633 65.7577 99.3658 65.7321 99.3032 66.9843C99.281 67.3339 99.1382 67.728 98.9397 68.2758L98.9396 68.276L98.939 68.2776C98.9041 68.3739 98.8675 68.4749 98.8296 68.5813C98.6795 68.9852 98.3694 69.3852 97.8325 69.0739C97.5986 68.9278 97.4064 68.7258 97.4185 68.4456C97.4415 68.056 97.5076 67.8116 97.5479 67.6624C97.5846 67.5267 97.6001 67.4696 97.5424 67.4536C97.4183 67.4191 96.0666 68.384 95.5218 68.7781L95.9049 69.0218C95.9049 69.0218 94.477 70.6549 93.6599 71.4421C92.9233 72.1459 91.418 71.5437 91.418 71.5437L85.7292 76.6056L83.4256 72.738L88.7459 66.0166L88.291 65.8135C88.291 65.8135 88.6658 65.5276 89.1874 65.1314C89.3207 64.6301 89.5185 64.1672 89.8069 64.0207C90.0277 63.9051 90.3522 63.917 90.6961 63.989Z",
    fill: "#D7AE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7913 69.9927L78.6455 74.6457C80.5205 76.0977 84.4788 78.8829 85.3121 78.4077C86.1454 77.9325 89.8954 73.8537 91.6662 71.8737C91.1662 70.9233 86.8746 70.2237 84.7913 69.9927Z",
    fill: "#E62645"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssistantCtaPage3);
export default __webpack_public_path__ + "static/media/icon-assistant-cta-page-3.05f8dd7a14dc2052b4554229fd2d1cac.svg";
export { ForwardRef as ReactComponent };